import styled from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;                   
  padding: 20px;           
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
`;

export const FormTitle = styled.h3`
  font-size: 14px;              /* 15 → 14 */
  font-weight: 700;
  margin: 0 0 2px 0;
  border-left: 3px solid #1fc7d4;
  padding-left: 6px;
  line-height: 1.2;
  color: #1a1a1a;
`;

export const RowTwoCol = styled.div`
  display: flex;
  gap: 8px;                     /* 两列间距：10 → 8 */
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;                     /* Label 到输入框：3 → 2 */
  min-width: 0;
  flex: 1;
`;

export const FormItemFull = styled(FormItem)`
  flex: 1 1 100%;
  width: 100%;
`;

export const FormLabel = styled.div`
  font-weight: 500;
  color: #334155;
  font-size: 11px;           
  line-height: 1.2;
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const ClearButton = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;

  img {
    width: 20px;                /* 12 → 10 */
    height: 20px;
    opacity: 0.5;
  }
  &:hover img {
    opacity: 0.8;
  }
`;

export const SelectWrapper = styled.div`
  width: 100%;
  position: relative;

  
`;

export const VipTip = styled.div`
  margin-top: 0px;
  color: #1fc7d4;
  font-size: 11px;              /* 12 → 11 */
  line-height: 1.2;
`;